import React, { useEffect } from 'react';
import {
  Button,
  ButtonGroup,
  Checkbox,
  CircularProgress,
  Tooltip,
  makeStyles,
  Switch,
  FormControlLabel
} from '@material-ui/core';
import ResultCard from './ResultCard';
import GetAppIcon from '@material-ui/icons/GetApp';
import { post, get, handleResponse } from '../../utils/network';
import { fetchImage, downloadFile, downloadZip } from '../../utils/downloadFiles';
import { toast, ToastContainer } from 'react-toastify'
import { deleteCookie } from '../../utils/utils';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2'
var humanize = require('humanize');

const useStyles = makeStyles(() => ({
  resultCheckbox: {
    '&.Mui-checked': {
      color: '#1d558c',
    },

    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: '-3rem'
  },
}));

export default function ResultSet({ loading, results, query, docTypes }) {
  const [selectedBoxes, SetSelectedBoxes] = React.useState(new Array(results.paginatedDocuments.length).fill(false));
  const [ docSize, setDocSize ] = React.useState(0);
  const isAllChecked = selectedBoxes.includes(false) ? false : true;
  const nothingChecked = selectedBoxes.includes(true) ? false : true;
  const [groupDocuments, setGroupDocuments] = React.useState(false);
  const [isLastPage, setIsLastPage] = React.useState(false);
  const [ maxSize, setMaxSize ] = React.useState(10000000);
  const [ pagedResults, setPagedResults ] = React.useState(results)
  const [ loadingPage, setLoadingPage ] = React.useState(false)
  const [ downloading, setDownloading ] = React.useState(false)
  const [ committedQuery, setCommittedQuery ] = React.useState({...query, page: 1})

  const classes = useStyles();

  useEffect(() => {
    setIsLastPage(false)
    setPagedResults(results)
    setCommittedQuery({...query, page: 1})

    get('config')
      .then(res => handleResponse(res))
      .then(resConfig => {
        setMaxSize(resConfig.message.data[0].config.maxFileSize)
      })
      .catch(err => {
        console.error(err)
      })
  }, [results]);

  const toastNotification = () => {
    toast.success('Descarga finalizada', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: "light"
    });
  }

  const checkAll = () => {
    if (isAllChecked) {
      SetSelectedBoxes(selectedBoxes.map(a => false));
      setDocSize(0)
      return;
    }
    var counter = 0
    SetSelectedBoxes(selectedBoxes.map(a => true))
    pagedResults.paginatedDocuments.forEach((r) => {
      if (typeof r.size === 'number') {
        counter = counter + r.size
      }
    })
    setDocSize(counter)
  };

  //Variable para manejar el tamaño maximo de descarga (100mb)
  // const getMaxSize = () => {
  //   get('config')
  //     .then(res => handleResponse(res))
  //     .then(resConfig => {
  //         if (resConfig && resConfig.message && resConfig.message.data && resConfig.message.data[0] && resConfig.message.data[0].config) {
  //           setMaxSize(resConfig.message.data[0].config.maxFileSize)
  //         } else {
  //             throw new Error("Invalid response structure");
  //         }
  //     })
  //     .catch(err => {
  //         console.error(err)
  //     })
  // }
  // getMaxSize()

  const handleCheck = async (i) => {
    var counter = 0
    const selected = selectedBoxes.map((b, j) => (j === i ? !b : b))
    SetSelectedBoxes(selected)
    selected.forEach((j, i)=>{
      if (j && typeof pagedResults.paginatedDocuments[i].size == 'number') {
        counter = counter + pagedResults.paginatedDocuments[i].size
      }
    })
    const allSelected = selected.every(b => b)

    setDocSize(counter)
  }

  const handleDownloads = async () => {
    let counter = 0 
    /*let downloadPromises = [];
  
    if (nothingChecked) {
      downloadPromises = results.map((r, i) => {
        return multipleDownloads(r.name);
      });
    } else {
      downloadPromises = results.map((r, i) => {
        if (selectedBoxes[i]) {
          return multipleDownloads(r.name);
        }
      })
    }
    await Promise.all(downloadPromises);*/
    const selectedDocuments = []

    if (nothingChecked || isAllChecked) {
      selectedDocuments.push(...pagedResults.paginatedDocuments)
    } else {
      pagedResults.paginatedDocuments.map((r, i) => {
        if (selectedBoxes[i]) {
          selectedDocuments.push(r)
        }
      })
    }

    selectedDocuments.forEach((r) => {
      if (typeof r.size === 'number') {
        counter = counter + r.size
      }
    })
    if (counter > maxSize) {

      Swal.fire({
        title: 'Atención!',
        text: 'El tamaño de la descarga es mayor al permitido, desea continuar?',
        icon: 'warning',
        confirmButtonText: 'Descargar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        
        if (result.isConfirmed) {
          toast.info('⬇️ Descargando documentos', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light"
          });

          setDownloading(true)
          
          post(`documents/zip/files`, {files: selectedDocuments, group: groupDocuments})
          .then(async (res) => {
            console.log("Receiving ZIP")
            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            downloadZip(url, `Documentos ${new Intl.DateTimeFormat("sv-SE", { 
              year: "numeric", month: "2-digit", day: "2-digit", 
              hour: "2-digit", minute: "2-digit", second: "2-digit"
            }).format(new Date())}.zip`)
          })
          .then(() => {
            setDownloading(false)
            toastNotification();
          })
        }
      })
    } else {
      toast.info('⬇️ Descargando documentos', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light"
          });

          setDownloading(true)
          
          post(`documents/zip/files`, {files: selectedDocuments, group: groupDocuments})
          .then(async (res) => {
            console.log("Receiving ZIP")
            const blob = await res.blob();
            const url = window.URL.createObjectURL(blob);
            downloadZip(url, `Documentos ${new Intl.DateTimeFormat("sv-SE", { 
              year: "numeric", month: "2-digit", day: "2-digit", 
              hour: "2-digit", minute: "2-digit", second: "2-digit"
            }).format(new Date())}.zip`)
          })
          .then(() => {
            setDownloading(false)
            toastNotification();
          })
    }
  
  };

  const loadMoreDocuments = () => {
    const nextPage = (committedQuery.page || 1) + 1;
    const params = {...committedQuery, page: nextPage};
    for (const key in committedQuery.advancedFilters) {
      params[key] = committedQuery.advancedFilters[key];
    }
    delete params.advancedFilters;

    setLoadingPage(true);
    get('documents?' + Object.keys(params).map(key => `${key}=${params[key]}`).join('&'))
      .then(response => {
        if (response.status === 401) {
          deleteCookie('isLogged');
          window.location.href = '/#/logout'
        }
        return response.json()
      })
      .then(res => {
        setLoadingPage(false);
        setCommittedQuery({...committedQuery, page: nextPage});
        if (res.paginatedDocuments.length === 0) setIsLastPage(true);
        pushDocuments(res);
      })
      .catch(error => console.log('error', error));
  };

  const pushDocuments = (result) => {
    result.paginatedDocuments.forEach((r, i) => {
      SetSelectedBoxes(selectedBoxes => [...selectedBoxes, false]);
      setPagedResults(pagedResults => ({ ...pagedResults, paginatedDocuments: [...pagedResults.paginatedDocuments, r] }));
    })    
  }
  
  /*const multipleDownloads = async (filename) => {
    const fileSource = `documents/${filename}/file`;
    return fetchImage(fileSource)
      .then(url => downloadFile(url, filename));
  }; */
  return (
    <div>
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}>
          <CircularProgress size={80}/>
        </div>
      ) : (
        <div>
          {pagedResults.paginatedDocuments.length === 0 ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: '3rem',
              }}
            >
              <span style={{ fontSize: '1.5rem' }}>
                No se encontraron documentos con ese criterio
              </span>
              <span style={{ fontSize: '1.2rem', color: '#999' }}>Intente otra consulta</span>
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr',
                  //   flexDirection: 'column',
                  gap: 10,
                  paddingBottom: '1rem',
                }}
              >
                <div></div>
                <div>
                  <ButtonGroup disableElevation variant="contained">
                    <Button onClick={checkAll}>
                      {isAllChecked ? 'Deseleccionar' : 'Seleccionar todo'}
                    </Button>                    {
                        <>{
                            downloading ?
                              <Button
                                style={{
                                  backgroundColor: '#25265d',
                                  color: 'white',
                                }}
                                color="secondary"
                                disabled
                              >
                                Descargando...  <CircularProgress size={20} style={{ padding:'0 0.5rem'}}/>
                              </Button>
                              :
                              <Button
                              style={nothingChecked ? {} : {
                                backgroundColor: '#25265d',
                                color: 'white',
                              }}
                              color="secondary"
                              onClick={handleDownloads}
                              endIcon={<GetAppIcon />}
                              disabled={nothingChecked}
                              >
                              Descargar Selección
                              </Button>
                          }
                        </>
                    }
                    <Button>
                      {humanize.filesize(docSize)} / {humanize.filesize(maxSize)}
                    </Button>
                  </ButtonGroup>
                  <FormControlLabel control={<Switch checked={groupDocuments} onChange={() => setGroupDocuments(!groupDocuments)} />} label="Agrupar documentos"  style={{marginLeft: '1rem'}}/>
                </div>
                {pagedResults.paginatedDocuments.map((result, i) => (
                  <div key={i} style={{position: 'relative'}}>
                    <Checkbox
                      disableRipple
                      classes={{ root: classes.resultCheckbox }}
                      onClick={() => {
                        handleCheck(i);
                      }}
                      checked={selectedBoxes[i]}
                    />

                    <ResultCard
                      result={result}
                      docType={docTypes}
                      style={{
                        border: selectedBoxes[i] ? '1px solid #25265d' : 'none',
                        padding: selectedBoxes[i] ? '0' : '1px',
                      }}
                    />
                  </div>
                ))}
              </div>
              <div style={{
                      display: 'flex',
                      justifyContent: 'space-evenly',
                      alignItems: 'center',
                      width: '100%',
                      paddingBottom: '3rem',  
                    }}>
                { !isLastPage && !loadingPage &&
                    <Button onClick={loadMoreDocuments}
                      style={{
                        backgroundColor: '#25265d',
                        color: 'white',
                        marginTop: '1rem',
                        padding: '0.5rem'
                      }}
                    >
                      Mostrar mas resultados
                    </Button>
                }
                { !isLastPage && loadingPage && <span style={{ padding: '1rem' }} >Cargando documentos...</span> }
                { isLastPage && <span style={{ padding: '1rem' }} >No hay mas resultados</span> }
              </div> 
            </div>
          )}
        </div>
      )}
      <ToastContainer />
    </div>
  );
}
